import React from 'react';
import Navigation from '../../components/Navigation/Navigation';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import AboutMission from '../../components/AboutMission/AboutMission';
import Footer from '../../components/Footer/Footer';

const AboutPage = () => {
    return (
        <div>
            <Navigation />
            <BreadCrumb />
            <AboutMission />
            <Footer />
        </div>
    );
};

export default AboutPage;